import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SIM_CARDS } from '../apiUrls';
import simCardFields from '../../fields/simCardFields';

/**
 * @param offers
 * @returns Mapped data object
 */
function mapResponseData(offers) {

    const mappedItems = offers.map((item) => {
        return {
            [simCardFields.SIM_OFFERS.UUID.key]: item[simCardFields.SIM_OFFERS.UUID.key],
            [simCardFields.SIM_OFFERS.DISPLAY_NAME.altKey]: item[simCardFields.SIM_OFFERS.DISPLAY_NAME.altKey]
        };
    });

    return mappedItems;
}

const queryGetSimPayviewOffers = (enabled) => {
    return {
        queryKey: [SIM_CARDS.PAYVIEW_OFFERS.queryKey],
        queryFn: async () => {
            const response = await client.get(SIM_CARDS.PAYVIEW_OFFERS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSimPayviewOffers;